module.exports = __webpack_public_path__ + "fonts/Inter-200-vietnamese12.9df1755.woff2";